// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lickitung: PokeData = {
  "id": 108,
  "name": "lickitung",
  "height": 12,
  "weight": 655,
  "base_experience": 77,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "bind",
    "slam",
    "stomp",
    "tackle",
    "wrap",
    "thrash",
    "double-edge",
    "supersonic",
    "disable",
    "acid",
    "screech",
    "defense-curl",
    "lick",
    "rest",
    "belly-drum",
    "rollout",
    "knock-off",
    "refresh",
    "wring-out",
    "me-first",
    "giga-impact",
    "zen-headbutt",
    "power-whip",
    "chip-away",
    "bulldoze"
  ],
  "moves": [
    "tackle",
    "supersonic",
    "acid",
    "lick",
    "refresh",
    "zen-headbutt",
    "power-whip",
    "tri-attack",
    "headbutt",
    "splash",
    "protect",
    "growl",
    "scary-face"
  ],
  "evolution_chain": {
    "id": 48,
    "item": null,
    "species": [
      {
        "name": "lickitung",
        "order": 119,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lickilicky",
        "order": 120,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 108,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "rollout"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 82.5,
    "speed": 30,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
